import React from 'react'

import { Card, CardMedia, CardContent, Box, Typography } from '@mui/material'

import { IClipGroup } from '../../../api/Data'
import VideoImagePlaceholder from '../../../_images/video-upload-placeholder.jpg'
import moment from '../../../utils/Moment'
import { formatNumber } from '../../../utils/sharedFunctions'

// Interface

const GalleryClipGroupCard = (props: IProps) => {
  // Props
  const { clipGroup, handleClipGroupSelection } = props

  const { clips } = clipGroup

  const { createdAt, contributor, imageLowResUrl, processingPosterUrl } = clips[0]
  const previewImageUrl = processingPosterUrl || imageLowResUrl

  return (
    <Card sx={{ position: 'relative' }}>
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={previewImageUrl}
          src={previewImageUrl}
          onError={({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) => {
            currentTarget.onerror = null
            currentTarget.src = VideoImagePlaceholder
          }}
          sx={{
            aspectRatio: '16/9',
          }}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={1}
          onClick={() => handleClipGroupSelection(clipGroup)}
          sx={{
            position: 'absolute',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            textAlign: 'center',
            color: '#ffffff',
            cursor: 'pointer',
          }}
        >
          View {clips.length === 1 ? '1 clip' : `${formatNumber(clips.length)} clips`}
        </Box>
      </Box>
      <CardContent sx={{ minHeight: '120px', padding: '10px !important' }}>
        <Box display="flex" flexDirection="column">
          <Typography variant="body2" color="textSecondary">
            {moment(createdAt).format('ll')}
          </Typography>
          <Typography variant="body2">{contributor || 'unknown'}</Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  clipGroup: IClipGroup
  handleClipGroupSelection: (arg: IClipGroup) => void
}

export default GalleryClipGroupCard
